(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["counter"] && !Shopify.designMode) return;
  try {
    class CounterNumber extends HTMLElement {
    connectedCallback() {
      this.valueEl = this.querySelector('[data-counter-value]');
      this.target = parseFloat(this.dataset.target) || 0;
      this.start = parseFloat(this.dataset.start) || 0;
      this.duration = (parseFloat(this.dataset.duration) || 2) * 1000;
      this.hasRun = false;
      this.decimals = (this.target.toString().split('.')[1] || '').length;

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !this.hasRun) {
              this.hasRun = true;
              this.animate();
              this.observer.disconnect();
            }
          });
        }, { threshold: 0.4 });
        this.observer.observe(this);
      } else {
        this.animate();
      }
    }

    format(n) {
      return n.toLocaleString(undefined, {
        minimumFractionDigits: this.decimals,
        maximumFractionDigits: this.decimals,
      });
    }

    animate() {
      const startTime = performance.now();
      const range = this.target - this.start;
      const tick = (now) => {
        const progress = Math.min((now - startTime) / this.duration, 1);
        const eased = 1 - Math.pow(1 - progress, 3);
        this.valueEl.textContent = this.format(this.start + range * eased);
        if (progress < 1) {
          requestAnimationFrame(tick);
        } else {
          this.valueEl.textContent = this.format(this.target);
        }
      };
      requestAnimationFrame(tick);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }
  }

  if (!customElements.get('counter-number')) {
    customElements.define('counter-number', CounterNumber);
  }
  } catch(e) { console.error(e); }
})();

})();
